export const pointLoadMagnitude = (load: PointLoad) => Math.abs(load.force.z)

/** Largest value of the given point loads (0 without loads). */
export const maxPointLoadMagnitude = (loads: PointLoad[]) =>
  loads.reduce((max, load) => Math.max(max, pointLoadMagnitude(load)), 0)

export interface FloorplanPointLoadScale {
  /** Largest load value; it is drawn with `maxDiameter`. */
  maxMagnitude: number
  /** Diameter (m) of the circle of `maxMagnitude`. */
  maxDiameter: number
  /** Smallest circle diameter (m), so small loads stay visible. */
  minDiameter: number
}

/**
 * Radius (m) of a point load circle, proportional to its value: `maxMagnitude` is drawn with
 * `maxDiameter`, but every circle is at least `minDiameter` wide so small loads stay visible.
 */
export const pointLoadRadius = (
  magnitude: number,
  { maxMagnitude, maxDiameter, minDiameter }: FloorplanPointLoadScale,
) => {
  if (!(maxDiameter > 0)) return 0
  const minRadius = Math.max(0, minDiameter / 2)
  if (!(maxMagnitude > 0)) return minRadius
  return Math.max(minRadius, (maxDiameter / 2) * (Math.abs(magnitude) / maxMagnitude))
}
